/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "fulfillment": {
                "nested": {
                  "preferences": {
                    "nested": {
                      "fedex_verification": {
                        "nested": {
                          "FedExVerificationStatus": {
                            "values": {
                              "FEDEX_VERIFICATION_STATUS_DO_NOT_USE": 0,
                              "NOT_REQUIRED": 1,
                              "NOT_STARTED": 2,
                              "PENDING": 3,
                              "COMPLETE": 4,
                              "FAILED": 5
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.fedex_verification?.nested?.FedExVerificationStatus) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Verification status for FedEx BYOA carrier accounts.
 *
 * SOURCE FedExVerificationStatus @ squareup/fulfillment/preferences/fedex_verification/models.proto at 41:1
 */
export const FedExVerificationStatus = $root.lookupEnum('squareup.connect.v2.fulfillment.preferences.fedex_verification.FedExVerificationStatus').values;